(function() {
  let featuredCollectionSlider;
  let isUpdatingContent = false;

  const stopVideo = (section) => {
    const videos = section.querySelectorAll('video');
    if (videos) {
      videos.forEach(video => video.pause());
    }
  }

  const playVideo = (section) => {
    const videos = section.querySelectorAll('video');
    const slides = section.querySelectorAll('.featured-collection__slider .swiper-slide');

    if (videos.length > 0 && slides.length > 0) {
      slides.forEach(slide => {
        if (slide.querySelector('video')) {
          if (slide.classList.contains('swiper-slide-visible'))
            slide.querySelector('video').play();
          else
            slide.querySelector('video').pause();
        }
      });
    }
  }

  const updateDynamicContent = (section, title, description) => {
    const titleEl = section.querySelector('[data-dynamic-title]');
    const descriptionWrapper = section.querySelector('.featured-collection__dynamic-description-wrapper');

    if (titleEl) {
      titleEl.textContent = title;
    }

    if (descriptionWrapper) {
      const descriptionEl = descriptionWrapper.querySelector('[data-dynamic-description]');

      if (description && description.trim() !== '') {
        if (descriptionEl) {
          descriptionEl.textContent = description;
        } else {
          const newDesc = document.createElement('p');
          newDesc.className = 'featured-collection__dynamic-description';
          newDesc.setAttribute('data-dynamic-description', '');
          newDesc.textContent = description;
          descriptionWrapper.innerHTML = '';
          descriptionWrapper.appendChild(newDesc);
        }
      } else {
        descriptionWrapper.innerHTML = '';
      }
    }
  }

  const updateMobileCta = (section, bullet) => {
    const mobileCta = section.querySelector('[data-dynamic-cta]');
    if (!mobileCta || !bullet) return;

    const blockUrl = bullet.getAttribute('data-block-url') || bullet.getAttribute('href');
    if (blockUrl) {
      mobileCta.href = blockUrl;
    }
  };

  const updateTabs = (bullets, index, section) => {
    bullets.forEach(b => b.classList.remove('featured-collection__tabs-item--active'));
    if (bullets[index]) {
      bullets[index].classList.add('featured-collection__tabs-item--active');
      const blockTitle = bullets[index].getAttribute('data-block-title');
      const blockDescription = bullets[index].getAttribute('data-block-description');
      if (blockTitle) {
        updateDynamicContent(section, blockTitle, blockDescription);
      }
      updateMobileCta(section, bullets[index]);
    }
  }

  const initSlider = () => {
    const featuredCollectionSliders = document.querySelectorAll('.js-collection-slider');

    featuredCollectionSliders.forEach((slider) => {
      const swiperInstance = new Swiper(slider, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          990: {
            autoplay: {
              delay: slider.dataset.duration * 1000,
              disableOnInteraction: false
            }
          }
        },
        on: {
          afterInit: function() {
            const container = this.el.closest('.featured-collection__container');
            const section = this.el.closest('[data-collection-section]');
            const featuredCollection = this.el.closest('.featured-collection');
            const bullets = container.querySelectorAll('.featured-collection__tabs-item');
            const isStatic = featuredCollection.classList.contains('featured-collection--static');
            const swiper = this;

            // Stop autoplay if static
            if (isStatic) {
              this.autoplay.stop();
            } else {
              this.autoplay.start();
            }

            // Tab click handler
            const tabClickHandler = (e) => {
              const target = e.target.closest('.featured-collection__tabs-item');
              if (!target) return;

              e.preventDefault();
              e.stopPropagation();

              const blockIndex = parseInt(target.getAttribute('data-block-index'));
              if (isNaN(blockIndex)) return;

              isUpdatingContent = true;
              updateTabs(bullets, blockIndex, section);
              swiper.slideTo(blockIndex, 300);
              isUpdatingContent = false;
            };

            if (isStatic) {
              featuredCollection.addEventListener('mouseover', tabClickHandler);
            } else {
              featuredCollection.addEventListener('click', tabClickHandler);
            }

            // Desktop autoplay pause/resume on hover
            if (window.matchMedia('(min-width: 990px)').matches) {
              this.el.addEventListener('mouseenter', () => {
                const activeBulletSpan = container.querySelector('.featured-collection__tabs-item--active span');
                if (activeBulletSpan) activeBulletSpan.style.animationPlayState = 'paused';
                swiper.autoplay.pause();
              });

              this.el.addEventListener('mouseleave', () => {
                const activeBulletSpan = container.querySelector('.featured-collection__tabs-item--active span');
                if (activeBulletSpan) activeBulletSpan.style.animationPlayState = 'running';
                swiper.autoplay.resume();
              });
            }
          },

          // slideChange fires for ALL navigation: arrows, swipe, autoplay, slideTo
          // This is the single source of truth for syncing tabs
          slideChange: function() {
            if (isUpdatingContent) return;

            const container = this.el.closest('.featured-collection__container');
            const section = this.el.closest('[data-collection-section]');
            const bullets = container.querySelectorAll('.featured-collection__tabs-item');

            updateTabs(bullets, this.activeIndex, section);
            playVideo(this.el.closest('.featured-collection'));
          }
        }
      });

      featuredCollectionSlider = swiperInstance;
    });
  }

  const destroySlider = () => {
    if (featuredCollectionSlider !== undefined) {
      featuredCollectionSlider.destroy(true, true);
    }
  };

  const initSection = () => {
    const featuredCollectionSection = document.querySelectorAll('[data-collection-section]');

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) playVideo(entry.target);
        else stopVideo(entry.target);
      });
    });

    const sectionResizeObserver = new ResizeObserver((entries) => {
      destroySlider();
      initSlider();
      const [entry] = entries;
      playVideo(entry.target);
    });

    destroySlider();
    initSlider();

    featuredCollectionSection.forEach(section => {
      sectionObserver.observe(section);
      sectionResizeObserver.observe(section);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });

  initSection();
})();